module.exports = __webpack_public_path__ + "img/book_6_en.7003e968.png";